import { render, staticRenderFns } from "./QuizHome.vue?vue&type=template&id=42ffb85a"
import script from "./QuizHome.vue?vue&type=script&lang=js"
export * from "./QuizHome.vue?vue&type=script&lang=js"
import style0 from "./QuizHome.vue?vue&type=style&index=0&id=42ffb85a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports